import { sendToParent } from "@connect/post-message/protocol";
import { clearCredentials } from "@connect/credentials-storage";
import { clearFingerprintCache } from "@connect/fingerprint";
import { logCredentialsDiagnostics } from "../../lib/credentials-diagnostics.ts";
import type { FrameConfig } from "./config.ts";

export async function reset(config: FrameConfig) {
  try {
    clearFingerprintCache();
    await logCredentialsDiagnostics("clear_reset");
    await clearCredentials();
    sendToParent(config.channelId, "complete");
  } catch (err) {
    const message = err instanceof Error ? err.message : "Failed to clear session";
    sendToParent(config.channelId, "error", { code: "generic", message });
  }
}
